import React from 'react';
import IframeWidget from "./IframeWidget";
import AppConfig from "../services/AppConfig";
import {MenuProductViewType} from "../services/Api/types";

interface Props {
    to: string;
    sectionMargin: number;
    isFirstElement: boolean;
    children: React.ReactNode;
    productsViewType: MenuProductViewType;
}

const ScrollMenuTo = ({to, sectionMargin, isFirstElement, children, productsViewType}: Props) => {
    let innerSectionMargin = sectionMargin;

    if (AppConfig.isWidget()) {
        innerSectionMargin += 60;
    }

    function scrollTo(elementId: any, e: any) {
        e.preventDefault();
        const element = document.getElementById(elementId);

        if (element !== null) {
            const sectionTopSpace = productsViewType === MenuProductViewType.HORIZONTAL ? 24 : 16;
            const scrollToValue = element.offsetTop - innerSectionMargin - sectionTopSpace;

            if (AppConfig.isWidget()) {
                IframeWidget.scrollTo(scrollToValue);
            } else {
                if (isFirstElement) {
                    window.scrollTo({top: scrollToValue, left: 0, behavior: 'smooth'});
                } else {
                    window.scrollTo({top: scrollToValue, behavior: 'smooth'});
                }
            }
        }
    }

    return (
        <a href="#" className="nav-link" onClick={(e) => scrollTo(to, e)}>
            {children}
        </a>
    )
}
export default ScrollMenuTo;

